// Field names match the galaxy_wit AppSync schema (SponsoredProductsSPFInfraCommon
// lib/galaxy_wit/app_sync/schema/schema.graphql), which uses the jobs table column names.
export const LIST_JOBS = /* GraphQL */ `
  query ListJobs($limit: Int, $nextToken: String) {
    listJobs(limit: $limit, nextToken: $nextToken) {
      items {
        job_id
        status
        weblab
        marketplace
        owner
        created_at
      }
      nextToken
    }
  }
`;

export const GET_JOB = /* GraphQL */ `
  query GetJob($job_id: ID!) {
    getJob(job_id: $job_id) {
      job_id
      owner
      status
      weblab
      marketplace
      data_source
      weblab_trigger_source
      treatments
      cohorts
      metrics
      start_date
      end_date
      created_at
      started_at
      ended_at
      failure {
        stage
        errorType
        table
        date
        message
      }
      resultFiles {
        key
        sizeBytes
        url
        expiresAt
      }
    }
  }
`;

export interface JobSummary {
  job_id: string;
  status: string;
  weblab: string;
  marketplace: string;
  owner: string;
  created_at: string | null;
}

export interface JobFailure {
  stage: string | null;
  errorType: string | null;
  table: string | null;
  date: string | null;
  message: string | null;
}

export interface ResultFile {
  key: string;
  sizeBytes: number | null;
  url: string;
  expiresAt: string;
}

export interface JobDetail {
  job_id: string;
  owner: string;
  status: string;
  weblab: string;
  marketplace: string;
  data_source: string;
  weblab_trigger_source: string;
  treatments: string;
  cohorts: string;
  metrics: string;
  start_date: string;
  end_date: string;
  created_at: string | null;
  started_at: string | null;
  ended_at: string | null;
  failure: JobFailure | null;
  resultFiles: ResultFile[] | null;
}

export interface ListJobsResult {
  listJobs: { items: JobSummary[]; nextToken: string | null };
}

export interface GetJobResult {
  getJob: JobDetail | null;
}
